import { useQuery } from '@tanstack/react-query'

import { getUserInfo } from '@/network/api/user'
import { useUserStore } from '@/store/user'

export const useUser = () => {
  const { setUser } = useUserStore()

  return useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const token = localStorage.getItem('bobai-token')
      if (!token) {
        throw new Error('No token found')
      }
      const data = await getUserInfo({})
      setUser(data)
      return data
    },
    retry: false,
  })
}
